import { useState, FormEvent } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { PublicHeader } from "../components/Header";
import { Button } from "../components/Button";
import { Input } from "../components/Input";
import { ErrorBanner } from "../components/ErrorBanner";
import { resetPassword } from "../api/auth";
import { setParentJwt } from "../api/client";

export function ResetPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";

  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError("");

    if (!token) {
      setError(
        "Токен сброса отсутствует или недействителен. Запросите новую ссылку."
      );
      return;
    }
    if (password !== passwordConfirm) {
      setError("Пароли не совпадают");
      return;
    }
    if (password.length < 8) {
      setError("Пароль должен быть не короче 8 символов");
      return;
    }
    if (!/\d/.test(password)) {
      setError("Пароль должен содержать хотя бы одну цифру");
      return;
    }

    setLoading(true);
    try {
      const res = await resetPassword(token, password);
      setParentJwt(res.token);
      navigate("/cabinet");
    } catch (err: unknown) {
      const ex = err as { response?: { data?: { detail?: string | unknown } } };
      const msg = ex?.response?.data?.detail;
      setError(
        typeof msg === "string"
          ? msg
          : "Не удалось сбросить пароль. Возможно, токен истёк."
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex flex-col">
      <PublicHeader />
      <main className="flex-1 flex items-center justify-center p-6">
        <form
          onSubmit={onSubmit}
          className="w-full max-w-md bg-white p-8 border border-[var(--color-line)]"
        >
          <h1
            className="text-3xl mb-2"
            style={{ fontFamily: "var(--font-serif)" }}
          >
            Новый пароль
          </h1>
          <p className="text-[var(--color-muted)] mb-6">
            Придумайте новый пароль для входа
          </p>

          <ErrorBanner message={error} />

          {!token && (
            <div className="px-4 py-3 bg-yellow-50 border-l-4 border-yellow-500 text-yellow-800 mb-4 text-sm">
              Ссылка для сброса некорректна. Запросите новую через{" "}
              <Link to="/forgot" className="underline">
                форму восстановления
              </Link>
              .
            </div>
          )}

          <Input
            label="Новый пароль"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            hint="Мин. 8 символов, обязательно цифра"
            autoComplete="new-password"
            disabled={!token}
          />
          <Input
            label="Повторите пароль"
            type="password"
            value={passwordConfirm}
            onChange={(e) => setPasswordConfirm(e.target.value)}
            required
            autoComplete="new-password"
            disabled={!token}
          />

          <Button
            type="submit"
            variant="primary"
            loading={loading}
            disabled={!token}
            className="w-full"
          >
            Установить пароль
          </Button>

          <div className="mt-4 text-center text-sm">
            <Link to="/login" className="text-[var(--color-accent)]">
              Войти
            </Link>
          </div>
        </form>
      </main>
    </div>
  );
}
